/* eslint-disable react/no-array-index-key */

import { Box, Divider, FlexLayout, GridLayout, H3, H4 } from '@deity/falcon-ui';
import { Icon } from '@deity-io/portal-ui';
import { Tooltip } from 'components/Tooltip';
import { CACHE_FIRST } from 'contracts/constants';
import { useGetModelQuery } from 'services/graphql/generated/hooks';

type StructureValidationProps = {
  params: { versionUuid: string; entityId: string };
  locked?: boolean;
};

export const StructureValidation: React.FC<StructureValidationProps> = ({ params, locked = false }) => {
  const {
    loading: loadingModel,
    data: modelData,
    refetch
  } = useGetModelQuery({
    variables: {
      packageVersionUuid: params.versionUuid,
      uuid: params.entityId
    },
    ...CACHE_FIRST
  });

  const validation = modelData?.getModel.validation;
  const messageCount = validation.messages?.reduce((acc, item) => acc + 1, 0);

  return (
    <Box p="xxl">
      <FlexLayout pb="xxl" justifyContent="space-between" alignItems="center">
        <Box key="info">
          <H4
            key="name"
            fontSize="xll"
            pt="xss"
            pb="xss"
            fontWeight="normal"
            mr="lg"
            border="regular"
            borderColor="transparent"
          >
            {modelData?.getModel.name}
          </H4>
          <FlexLayout flexDirection="row">
            {validation.valid ? <Icon icon="check" color="success" /> : <Icon icon="error" color="error" />}
            <H3 pl="xl" key="description" color="secondary">
              {validation.valid ? (
                <Box>The structure is valid</Box>
              ) : (
                <Box>
                  <H3 color="error">
                    {messageCount
                      ? `This structure was loaded with problems. Please correct them and save the structure`
                      : `Validation was not yet performed on this structure`}
                  </H3>
                </Box>
              )}
            </H3>
          </FlexLayout>
        </Box>
      </FlexLayout>

      <H3>Validation</H3>
      <Divider />
      <GridLayout gridTemplateColumns="1fr 20fr">
        {[
          ...(validation.messages?.map((message, index) => [
            <Icon key={`Icon${index}`} icon={message.type} color={message.type} />,
            <Tooltip content={`on path: ${message.path}`}>
              <Box key={`errorMessage${index}`}>{`${message.message}`}</Box>
            </Tooltip>
          ]) || [])
        ]}
      </GridLayout>
    </Box>
  );
};
